export const LOAD_CHAMPIONSHIP_ATTEMPT = 'championships/LOAD_CHAMPIONSHIP_ATTEMPT'
export const LOAD_CHAMPIONSHIP_SUCCESS = 'championships/LOAD_CHAMPIONSHIP_SUCCESS'
export const LOAD_CHAMPIONSHIP_FAILURE = 'championships/LOAD_CHAMPIONSHIP_FAILURE'

export const CREATE_CHAMPIONSHIP_ATTEMPT = 'championships/CREATE_CHAMPIONSHIP_ATTEMPT'
export const CREATE_CHAMPIONSHIP_SUCCESS = 'championships/CREATE_CHAMPIONSHIP_SUCCESS'
export const CREATE_CHAMPIONSHIP_FAILURE = 'championships/CREATE_CHAMPIONSHIP_FAILURE'

export const UPDATE_CHAMPIONSHIP_ATTEMPT = 'championships/UPDATE_CHAMPIONSHIP_ATTEMPT'
export const UPDATE_CHAMPIONSHIP_SUCCESS = 'championships/UPDATE_CHAMPIONSHIP_SUCCESS'
export const UPDATE_CHAMPIONSHIP_FAILURE = 'championships/UPDATE_CHAMPIONSHIP_FAILURE'

export const RESET_VALUE = 'championships/RESET_VALUE'

export const REACT_ATTEMPT = 'events/REACT_ATTEMPT'
export const REACT_SUCCESS = 'events/REACT_SUCCESS'
export const REACT_FAILURE = 'events/REACT_FAILURE'

export const SET_IMAGE_ATTEMPT = 'events/SET_IMAGE_ATTEMPT'
export const SET_IMAGE_SUCCESS = 'events/SET_IMAGE_SUCCESS'
export const SET_IMAGE_FAILURE = 'events/SET_IMAGE_FAILURE'

export const DELETE_IMAGE_ATTEMPT = 'events/DELETE_IMAGE_ATTEMPT'
export const DELETE_IMAGE_SUCCESS = 'events/DELETE_IMAGE_SUCCESS'
export const DELETE_IMAGE_FAILURE = 'events/DELETE_IMAGE_FAILURE'

export const LOAD_RESULTS_ATTEMPT = 'events/LOAD_RESULTS_ATTEMPT'
export const LOAD_RESULTS_SUCCESS = 'events/LOAD_RESULTS_SUCCESS'
export const LOAD_RESULTS_FAILURE = 'events/LOAD_RESULTS_FAILURE'

export const LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_ATTEMPT =
  'events/LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_ATTEMPT'
export const LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_SUCCESS =
  'events/LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_SUCCESS'
export const LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_FAILURE =
  'events/LOAD_EVENT_CIRCUIT_CATEGORY_RESULTS_FAILURE'
